import { FrontSide, LineBasicMaterial, MeshStandardMaterial } from "three";
import { ObjectType } from "../Constant";
export const CSG_MATERIAL = {
  [ObjectType.MESH]: new MeshStandardMaterial({
    color: 16777215,
    vertexColors: true,
    side: FrontSide,
    metalness: 0,
    roughness: 0.9
  }),
  [ObjectType.LINE_SEGMENTS]: new LineBasicMaterial({
    color: 16777215,
    linewidth: 1,
    vertexColors: true
  })
};
